import React from "react";
import * as Styled from "./styles.js";
import TextView from "../TextView/index.jsx";

export default function NewSidebar({
  title,
  options,
  selectedIndex,
  setSelectedIndex,
  style,
  maxHeight
}) {
  return (
    <Styled.SideBarOpened style={style}>
      {!!title && (
        <Styled.SideBarHeader>
          <Styled.Row>
            {/* <img
            alt="cstm"
            src={ASSETS.customizeIcon}
            style={{
              height: "35px",
              width: "35px",
            }}
          /> */}
            <TextView
              variant="subtitle"
              style={{ fontWeight: "bold", marginLeft: 16 }}
            >
              {title}
            </TextView>
          </Styled.Row>
        </Styled.SideBarHeader>
      )}
      <Styled.SideBarContent style={{ paddingTop: title ? 15 : 0,maxHeight,overflowY:"scroll" }}>
        {Object.keys(options).map((key) => {
          const { title, icon } = options[key];

          return (
            <Styled.MenuItemHeader
              onClick={() => setSelectedIndex(key)}
              isSelected={selectedIndex === key}
            >
              <Styled.Row>
                {/* <Styled.SideBarIcon
                  src={icon}
                  alt={title}
                  isSelected={selectedIndex === key}
                /> */}
                <TextView style={{ fontSize: 14, fontWeight: 500 }}>
                  {title}
                </TextView>
              </Styled.Row>
              {/* <Styled.MenuItemIcon
                src={ASSETS.DownArrow}
                isSelected={selectedIndex === key}
              /> */}
            </Styled.MenuItemHeader>
          );
        })}
      </Styled.SideBarContent>
    </Styled.SideBarOpened>
  );
}
